/*
	Author: xowei <wei@xowei.tw>
	Website: https://xowei.tw/
*/

$(function () {
	var $hud = $('.hud')
	var $preload = $('.preload')
	var $nav = $('nav')
	var $window = $(window)

	$hud.hide()
	$window.on({
		'scroll': function () {
			windowScroll = $(window).scrollTop()
	
			if (windowScroll < window.innerHeight) {
				if ($hud.length) $hud.hide()
			} else {
				if ($hud.length) $hud.show()
			}
	
			if ($nav.length) {
				windowScroll > 0 ? $nav.addClass('bg') : $nav.removeClass('bg')
			}
		},
		'load': function () {
			$preload.fadeOut('slow')
			initAnimation()
		}
	})

	navLinkClick('#navContent a')
	smoothScroll('#navContent a[href^="#"]')
	smoothScroll('#gototop')
})

function navLinkClick(target) {
	$(target).on('click', function () {
		if ($(this).attr('role') == 'dropdown') {
			$(this).toggleClass('list-open')
			$(this).siblings('ul').toggleClass('is-hidden')
		} else {
			$('.nav-icon').click()
		}
	})
}

function smoothScroll(target) {
	var $body = $('body, html')
	var $linkPosition
	var $nav = $('nav')

	$(target).each(function () {
		var $link = $(this)
		$linkPosition

		$link.on('click', function (e) {
			e.preventDefault()
			var tab = $link.attr('role')

			if (!tab) {
				var $target = $($(this).attr('href'))
				$iconHeight = $('.product-title .icon').height()
				$linkPosition = ($target.length ? $target.offset().top : 0) - $nav.height()

				if ($target.is(':not(":first-child")')) {
					$linkPosition -= $iconHeight / 2
				}

				$body.animate({
					scrollTop: $linkPosition,
				})
			}
			$(this).blur()
			$(this).focusout()
		})
	})
}

function initAnimation () {
	$('#product_a1, #product_a2').each(function () {
		var selfname = $(this)[0].id
		var image = $(this).find('[class$="-image"]')
		var msgBg = $(this).find('[class$="-MsgBg"]')
		var msgPaint = $(this).find('[class$="-MsgPaint"]')
		var infodt = $(this).find('[class$="-Infodt"]')
		var subInfodt = $(this).find('[class$="-subInfodt"]')
		var cta = $(this).find('[class$="-cta"]')

		image.attr({
			'data-aos': (selfname === 'product_a1') ? 'fade-left' : 'fade-right',
		})

		msgPaint.attr({
			'data-aos': 'fade-up',
			'data-aos-delay': 400
		})

		infodt.find('li').each(function (i) {
			$(this).attr({
				'data-aos': 'fade-up',
				'data-aos-delay': 50 * i
			})
		})

		subInfodt.attr({
			'data-aos': 'fade-up',
			'data-aos-delay': 600
		})
		
		cta.attr({
			'data-aos': 'fade-up',
			'data-aos-delay': 600
		})
	})

	$('.productc-content').each(function (i) {
		var isOdd = (i % 2 === 0) ? true : false
		var cta = $(this).find('[class$="-cta"]')

		$(this).attr({
			'data-aos': isOdd ? 'fade-right' : 'fade-left'
		})
		
		cta.attr({
			'data-aos': 'fade-up',
			'data-aos-delay': 200
		})
	})

	AOS.init({
		duration: 1000,
		once: true,
	})
}
